import { buildFormatLongFn } from "../../_lib/buildFormatLongFn.js";
var dateFormats = {
  full: "EEEE, d 'de' MMMM 'de' y",
  "long": "d 'de' MMMM 'de' y",
  medium: "d MMM y",
  "short": "dd/MM/y"
};
var timeFormats = {
  full: "HH:mm:ss zzzz",
  "long": "HH:mm:ss z",
  medium: "HH:mm:ss",
  "short": "HH:mm"
};
var dateTimeFormats = {
  full: "{{date}} 'a las' {{time}}",
  "long": "{{date}} 'a las' {{time}}",
  medium: "{{date}}, {{time}}",
  "short": "{{date}}, {{time}}"
};
export var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
};